import type { InvoiceRemarks } from './InvoiceRemarks';
import type OrderNomenclature from './OrderNomenclature';
import type PatientStatus from './PatientStatus';
import type PaymentMethod from './PaymentMethod';

export class InvoiceModel {
    AllOrderNomenclatures: OrderNomenclature[];
    CustomHonorarium: number;
    CustomSupplementHonorarium: number;
    CustomWIGW: number;
    CustomSupplementWIGW: number;
    CustomOther: number;
    CustomSupplementOther: number;
    CustomPractice: number;
    CustomSupplementPractice: number;
    CompanyPays: boolean;
    AmountPatient: number;
    TotalAmount: number;
    ThirdPayerPatientShare: number;
    ThirdPayerHealthInsuranceShare: number;
    Remarks: InvoiceRemarks;
    FreeOfCharge: boolean;
    ProcedureAndProductNomenclatures: OrderNomenclature[];
    TotalHonorarium: number;
    TotalWIGW: number;
    TotalOther: number;
    TotalPractice: number;
    PaymentMethod: PaymentMethod;
    PatientStatus: PatientStatus;
    DateOfImplementationString: string;

    constructor(allOrderNomenclatures: OrderNomenclature[], customHonorarium: number, customSupplementHonorarium: number, customWIGW: number, customSupplementWIGW: number,
        customOther: number, customSupplementOther: number, customPractice: number, customSupplementPractice: number,
        companyPays: boolean, amountPatient: number, totalAmount: number, thirdPayerPatientShare: number,
        thirdPayerHealthInsuranceShare: number, remarks: InvoiceRemarks, freeOfCharge: boolean,
        nomenclatures: OrderNomenclature[], totalHonorarium: number, totalWIGW: number, totalOther: number,
        totalPractice: number, paymentMethod: PaymentMethod, patientStatus: PatientStatus, dateOfImplementationString: string) {
        this.AllOrderNomenclatures = allOrderNomenclatures;
        this.CustomHonorarium = customHonorarium;
        this.CustomSupplementHonorarium = customSupplementHonorarium;
        this.CustomWIGW = customWIGW;
        this.CustomSupplementWIGW = customSupplementWIGW;
        this.CustomOther = customOther;
        this.CustomSupplementOther = customSupplementOther;
        this.CustomPractice = customPractice;
        this.CustomSupplementPractice = customSupplementPractice;
        this.CompanyPays = companyPays;
        this.AmountPatient = amountPatient;
        this.TotalAmount = totalAmount;
        this.ThirdPayerPatientShare = thirdPayerPatientShare;
        this.ThirdPayerHealthInsuranceShare = thirdPayerHealthInsuranceShare;
        this.Remarks = remarks;
        this.FreeOfCharge = freeOfCharge;
        this.ProcedureAndProductNomenclatures = nomenclatures;
        this.TotalHonorarium = totalHonorarium;
        this.TotalOther = totalOther;
        this.TotalWIGW = totalWIGW;
        this.TotalPractice = totalPractice;
        this.PaymentMethod = paymentMethod;
        this.PatientStatus = patientStatus;
        this.DateOfImplementationString = dateOfImplementationString;
    }
}
